<script lang="typescript">
    import config from "../config"

    import { activeNav, jsonForOverlay } from "../store"
</script>

{#if $activeNav}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <h3
        on:click="{() => {
            $jsonForOverlay = [$activeNav.xlsRow, $activeNav.online, $activeNav.diff]
        }}"
    >
        {$activeNav.name && $activeNav.name[config.defaultLanguage]}
    </h3>
{/if}
{#if $activeNav?.products?.length}
    <table cellspacing="0" cellpadding="0">
        <tr>
            <th>ID</th>
            <th>Name</th>
        </tr>
        {#each $activeNav.products as product}
            <tr
                on:click="{() => {
                    $jsonForOverlay = [product.xlsRow, product.online, product.diff]
                }}"
                class="{product.method}"
            >
                <td>{product.id}</td>
                <td>{product.name && product.name[config.defaultLanguage]}</td>
            </tr>
        {/each}
    </table>
{/if}

<style>
    th {
        text-align: left;
        padding: 5px;
    }
    td {
        padding: 5px;
        color: #444;
    }
    tr:nth-child(odd) td {
        background: #eee;
    }
    tr:hover td {
        font-weight: bold;
        cursor: pointer;
    }
    h3 {
        cursor: pointer;
    }
    .delete td {
        color: darkred;
        text-decoration: line-through;
    }
    .put td {
        color: darkorange;
    }
    .post td {
        color: darkgreen;
    }
</style>
